// useDynamicFont.ts

import {postFont} from "../worker/RenderWorkerManager.ts";
import useStore from "../store.ts";

export interface UseDynamicFontOptions {
    family: string;            // CSS font-family name (must match your CSS)
    url: string;               // direct font file URL (woff2 recommended)
    descriptors?: FontFaceDescriptors; // { weight, style, stretch, unicodeRange, display }
    preconnect?: string;       // optional: origin to preconnect if cross-site (manual step)
}

export async function useDynamicFont(opts: UseDynamicFontOptions) {
    const {family, url, descriptors} = opts;

    if (typeof document === 'undefined' || typeof FontFace === 'undefined') return;
    try {
        const buf = await ((await fetch(url)).arrayBuffer());
        const font = new FontFace(family, buf, descriptors);
        await font.load();
        document.fonts.add(font);
        try {
            const store = useStore();
            store.fonts.mainThreadLoaded.add(family);
        } catch (_e) {
            // Store may not be initialized yet; ignore.
        }
        // see docs/EXTRACTED_COMMENTS.md#c193
        await postFont(family, buf, descriptors);
    } catch (err) {
        console.error('Failed to load font', family, err);
    }
}
